import { ref, reactive } from 'vue'
import { useCompanyStore } from '@/stores/companyStore'
import { useUserStore } from '@/stores/userStore'
import { useApplicationStore } from '@/stores/applicationStore'

import useCashedData from './useCashedData'
import usePersonalCompanySettingsManager from '@/composables/managers/usePersonalCompanySettingsManager'

import DataTransferService from '@/services/dataTransferService'
const dataTransferService = DataTransferService()

export default function useCurrentCompany() {
	const userStore = useUserStore()
	const companyStore = useCompanyStore()
	const appStore = useApplicationStore()

	const {
		updateCacheData,
	} = useCashedData()

	const {
		getAllPersonalCompanySettings,
	} = usePersonalCompanySettingsManager()

	const isLoadingAllDataOfCompany = ref(false)

	const companyFlags = reactive({
		isLoading: false,
		isCreating: false,
		isUpdating: false,
		loaded: false,
	})

	const permissionsFlags = reactive({
		isLoading: false,
		isCreating: false,
		// isDeleting: false,
		isUpdating: false,
		loaded: false,
	})

	const getCurrentCompany = () => {
		return new Promise((resolve, reject) => {
			companyFlags.isLoading = true
			dataTransferService.company
				.getCompanyProfile({
					urlParams: {
						companyId: userStore.selectedCompanyId,
					},
				})
				.then((res) => {
					// console.log('getCurrentCompany then', res)
					companyFlags.isLoading = false
					companyStore.setCurrentCompany(res)
					resolve(res)
				})
				.catch((err) => {
					// console.log('getCurrentCompany catch', err)
					companyFlags.isLoading = false
					// appStore.addErrorNotify({ text: 'entities loaded with an error!' })
					reject(err)
				})
		})
	}

	const createCompany = (data) => {
		return new Promise((resolve, reject) => {
			companyFlags.isCreating = true
			dataTransferService.company.createCompany(data)
				.then((res) => {
					// console.log('getCurrentCompany then', res)
					companyFlags.isCreating = false
					companyStore.setCurrentCompany(res)
					resolve(res)
				})
				.catch((err) => {
					// console.log('getCurrentCompany catch', err)
					companyFlags.isCreating = false
					// appStore.addErrorNotify({ text: 'entities loaded with an error!' })
					reject(err)
				})
		})
	}

	const updateCurrentCompany = (data) => {
		return new Promise((resolve, reject) => {
			companyFlags.isUpdating = true
			dataTransferService.company.updateCompanyProfile(userStore.selectedCompanyId, data)
				.then((res) => {
					companyFlags.isUpdating = false
					companyStore.setCurrentCompany(res)
					appStore.addSuccessNotify({
						text: 'Профиль компании успешно обновлен',
					})
					resolve(res)
				})
				.catch((err) => {
					companyFlags.isUpdating = false
					// appStore.addErrorNotify({ text: 'entities loaded with an error!' })
					reject(err)
				})
		})
	}

	const getCurrentUserCompanyPermission = () => {
		return new Promise((resolve, reject) => {
			permissionsFlags.isLoading = true
			dataTransferService.company
				.getUserCompanyPermission({
					urlParams: {
						companyId: userStore.selectedCompanyId,
					},
				})
				.then((res) => {
					// console.log('getCurrentUserCompanyPermission', res)
					companyStore.setCurrentUserCompanyPermission(res)
					permissionsFlags.isLoading = false
					resolve(res)
				})
				.catch((err) => {
					permissionsFlags.isLoading = false
					reject(err)
				})
		})
	}

	const getAllDataOfCompany = () => {
		return new Promise((resolve) => {
			isLoadingAllDataOfCompany.value = true
			Promise.all([
				getCurrentCompany(),
				getCurrentUserCompanyPermission(),
				updateCacheData(),
				getAllPersonalCompanySettings(),
			])
				.then((res) => {
					isLoadingAllDataOfCompany.value = false
					resolve(res)
				})
		})
	}

	return {
		getCurrentCompany,
		createCompany,
		updateCurrentCompany,
		getCurrentUserCompanyPermission,
		isLoadingAllDataOfCompany,
		companyFlags,
		permissionsFlags,
		getAllDataOfCompany,
	}
}
